import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSidebarHistory = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="M11.844 21.75a9.77 9.77 0 0 1-9.4-7.141.75.75 0 1 1 1.446-.4 8.241 8.241 0 1 0 .762-6.275.75.75 0 0 1-1.3-.74 9.749 9.749 0 1 1 8.5 14.556z"
    />
    <path
      fill="currentColor"
      d="M7.04 8.318H3.759a.75.75 0 0 1-.75-.75v-3.3a.75.75 0 1 1 1.5 0v2.55h2.53a.75.75 0 1 1 0 1.5M8.822 15.317a.75.75 0 0 1-.385-1.393l2.81-1.679V8.572a.75.75 0 1 1 1.5 0v4.1a.75.75 0 0 1-.366.644l-3.174 1.9a.75.75 0 0 1-.385.101"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSidebarHistory);
export default ForwardRef;
